<template>
  <div class="row flex-center toptype">

    <div class="flex-1 typebtn" :class="bindActive==1?'active':''" @click="switchBindActive(1)">
      绑定患者
    </div>
    
    <div class="flex-1 typebtn" :class="bindActive==2?'active':''" @click="switchBindActive(2)">
      新建档案
    </div>
  
  </div>

  <div class="noPatientInformation flex-1 column" v-show="bindActive==1">
    <div class="noPatientInformation-text row">
      请输入患者手机号码或姓名查询患者信息
    </div>
    
    <div class="Searchpatient row">
      <!-- <div class="clinic row flex-center" @click="showSelectClinic">
        <div class="clinicname single-line-ellipsis">
          {{ topSearch.clinicName }}
        </div>
        <div class="iconfont icon-arr-xia"></div>
      </div> -->
      <div class="flex-1 nameinfo row flex-center">
        <!--输入框-->
        <input
          placeholder="请输入患者或手机号"
          class="nameinput"
          v-model.trim="userinfoname"
          maxlength="20"
        />
      </div>
      <div class="searchClick P-Cursor" @click="getListClick">搜索</div>
    </div>

    <!--门店切换-->
    <div class="clinic-box row"  @click="onShowSelectClinic">
      <div>
        查询范围：{{ topSearch.clinicName }}
      </div>
      <div class="clinic-box-right">
        <span>切换</span>
        <span class="iconfont icon-switch"></span>
      </div>
    </div>
   

    <div class="overflow-y flex-1 mt10" id="patientList">
      <!--患者列表-->
      <div class="patientList" v-if="isSearch && searchlist.length != 0">
        <div
          class="patientItem"
          v-for="(row, index) in searchlist"
          :key="index"
        >
          <div
            class="isSelect P-Cursor"
            :class="listSelect.id === row.id ? 'active' : ''"
            @click="SelectCurrent(row)"
          >
            <i class="iconfont icon-success"></i>
          </div>

          <div
            class="name row align-bottom P-Cursor"
            @click="SelectCurrent(row)"
          >
            <div class="main mr8">{{ row.patientName }}</div>
            <div class="mr8">{{ row.sexLabel }}</div>
            <div class="mr8" v-if="row.age">{{ row.age }}岁</div>
            <div>{{ row.contactNo1 }}</div>
          </div>
          <div class="row mt12">
            <div class="patient-left mr8">病历号：</div>
            <div class="patient-rightmain">
              {{ row.medicalNo }}
            </div>
          </div>

          <div class="row mt12">
            <div class="patient-left mr8">出生日期：</div>
            <div class="patient-rightmain">
              {{ row.birthday }}
            </div>
          </div>

          <div class="row mt12">
            <div class="patient-left mr8">创建门店：</div>
            <div class="patient-rightmain">
              {{ row.clinicName }}
            </div>
          </div>

          <div class="row mt12">
            <div class="patient-left mr8">患者来源：</div>
            <div class="patient-rightmain">
              <span>{{ row.firstSourceName }}</span>
              <span v-if="row.secondSourceName">|</span>{{ row.secondSourceName
              }}<span v-if="row.threeSourceName">|</span
              >{{ row.threeSourceName }}
            </div>
          </div>

          <div class="row mt8">
            <div class="patient-left mr8 mt2 mr8">患者标签：</div>
            <div class="patient-tag row flex-wrap">
              <div
                class="tagitem"
                v-for="(label, labelindex) in row.patientLabel"
                :key="labelindex"
              >
                {{ label.labelName || label.labelAbbreviation }}
              </div>
            </div>
          </div>

          <div v-if="row.isOpen">
            <div class="titleline mt8">客户关系</div>

            <div class="row mt8">
              <div class="row mr10 flex-1">
                <div class="patient-left">责任医生：</div>
                <div class="patient-rightmain">
                  {{ row.doctorName }}
                </div>
              </div>

              <div class="row flex-1">
                <div class="patient-left">咨询师：</div>
                <div class="patient-rightmain">
                  {{ row.consultantName }}
                </div>
              </div>
            </div>

            <div class="row mt8">
              <div class="row mr10 flex-1">
                <div class="patient-left">网电营销：</div>
                <div class="patient-rightmain">
                  {{ row.techSupportName }}
                </div>
              </div>

              <div class="row flex-1">
                <div class="patient-left">专属客服：</div>
                <div class="patient-rightmain">
                  {{ row.exclusiveTechSupportName }}
                </div>
              </div>
            </div>

            <div class="titleline mt8">就诊信息</div>

            <div class="row mt8">
              <div class="patient-left">初次就诊：</div>
              <div class="patient-rightmain">
                {{ $filters.formatDateTime(row.firstVisitTime) }}
                {{ row.firstVisitDoctorName }}
              </div>
            </div>

            <div class="row mt8">
              <div class="patient-left">上次就诊：</div>
              <div class="patient-rightmain">
                {{ $filters.formatDateTime(row.lastAppointTime) }}
                {{ row.lastVisitDoctorName }}
              </div>
            </div>

            <div class="titleline mt8">创建信息</div>

            <div class="row mt8">
              <div class="patient-left">创建日期：</div>
              <div class="patient-rightmain">
                {{ $filters.formatDateTime(row.createTime) }}
                {{ row.createEmployeeName }}
              </div>
            </div>
          </div>

          <!--更多-->
          <div class="seemore" v-if="!row.isOpen" @click="moreOpen(row, true)">
            更多信息 <i class="ml6 iconfont icon-arr-xia"></i>
          </div>

          <div class="seemore" v-if="row.isOpen" @click="moreOpen(row, false)">
            收起 <i class="ml6 iconfont icon-arr-shang"></i>
          </div>
        </div>
      </div>

      <!--未搜索到患者-->
      <EmptyImgh5
        v-if="isSearch && searchlist.length == 0"
        :emptyDataText="'未搜索到患者'"
        :emptyImageType="2"
      ></EmptyImgh5>

      <div class="searchPatientInformation" v-if="!isSearch">
        请先搜索患者信息
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y" v-show="bindActive==2">
    <CreateRecord
     ref="CreateRecordcontent"
    ></CreateRecord>
  </div>

  <!--选择门店-->
  <SelectStore
    v-if="selectStoreTip.isShow"
    :clinicList="clinicList"
    :self="selectStoreTip"
    @storeChange="onConfirm"
  >
  </SelectStore>
</template>

<script>
import {  getClinicListbyEmp } from "@/api/options.js";
import { userStore } from "@/store/user.js";
import func from "@/util/func.js";
import { getPatientList } from "@/api/patient.js";
import { contactCardProps } from "vant";
import { showToast } from "vant";
import { loadingStore } from "@/store/loading.js";

import SelectStore from "@/components/publick/selectStore.vue";

import CreateRecord from "@/components/personalCenter/tocreate/createRecord.vue"


export default {
  name: "noPatientInformation",
  props: [],
  components: {
    SelectStore,
    CreateRecord
  },
  data: function () {
    return {
      clinicList: [], //诊所列表

      topSearch: {
        clinicName: "全部门店",
        clinicId: [""],
      },
      userinfoname: "",
      isSearch: false, //是否进行了搜索
      searchlist: [],
      sortValues: "",
      pages: {
        size: 10,
        current: 1,
      },
      isEnd: false,
      isLoading: false,
      listSelect: {}, //当前选中的项目
      selectStoreTip: {
        isShow: false,
        current: "",
      },
      bindActive:1 //类型
    };
  },
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },

  mounted: function () {
    let that = this;
    this.getOptions();

    this.loaderMore("patientList", function () {
      that.loaderList();
    });
  },
  methods: {
    loaderMore(id = "scrollContent", loaderFn) {
      //监听页面上 id 为 id的元素 如果滚动到底部则执行加载方法 loaderFn
      //todo :可能方法要完善
      let that = this;
      const element = document.getElementById(id);
      element.addEventListener("scroll", () => {
        // 判断是否滚动到底部
        const isAtBottom =
          element.scrollTop + element.clientHeight >= element.scrollHeight - 20;

        if (isAtBottom && !that.isloading && !that.isFinish) {
          // 执行加载方法 loaderFn
          loaderFn();
        }
      });
    },
    getOptions() {
      let that = this;

      getClinicListbyEmp().then((res) => {
        let { data } = res.data;
        data.forEach((item) => {
          item.text = item.name;
        });

        data.unshift({
          key: "0",
          name: "全部门店",
          text: "全部门店",
          value: "",
        });

        that.clinicList = data;

        //默认取归属诊所
        const user = userStore();
        let item = that.clinicList.find((item) => {
          return item.value == user.userInfo.detail.clinic_id;
        });
        if (!func.isEmpty(item)) {
          that.topSearch.clinicName = item.name;
          that.topSearch.clinicId = [item.value];
        }

        
      });
    },
    onConfirm({ row }) {
      const selectedValues = row.value;
      let that = this;
      let { clinicList } = that;
      let item = clinicList.find((item) => {
        return item.value == selectedValues;
      });

      that.topSearch = {
        clinicName: item.name,
        clinicId: [item.value],
      };
      this.selectStoreTip.isShow = false;
    },

    onShowSelectClinic() {
      let that = this;

      this.selectStoreTip.current = this.topSearch.clinicId[0];
      this.selectStoreTip.isShow = true;
    },
    getListClick() {
      let that = this;
      if (that.isLoading) {
        return;
      }

      if (func.isEmpty(that.userinfoname)) {
        showToast("请先输入患者姓名或手机号");
        return;
      }

      that.sortValues = "";
      that.searchlist = [];
      that.pages.current = 1;
      that.isSearch = false;
      that.isEnd = false;
      that.listSelect = {};

      that.loaderList();
    },
    loaderList() {
      let that = this;

      if (that.isLoading || that.isEnd) {
        return false;
      }

      let { pages } = that;

      let subdata = {
        search: that.userinfoname,
        clinicId: that.topSearch.clinicId[0],
        sortValues: that.sortValues,
        ...pages,
      };

      that.isLoading = true;
      that.loading.showLoading();
      getPatientList(subdata).then((res) => {
        that.loading.hideLoading();

        that.isLoading = false;
        that.isSearch = true;
        that.pages.current++;

        let { records } = res.data.data;

        if (records.length > 0) {
          that.sortValues = records[records.length - 1].id;
        }
        records.forEach((item) => {
          item.isOpen = false;
          that.searchlist.push(item);
        });

        if (records.length < that.pages.size) {
          that.isEnd = true;
        }
      });
    },
    moreOpen(row, type) {
      row.isOpen = type;
    },
    SelectCurrent(row) {
      //选中当前的项
      let that = this;
      that.listSelect = row;
    },
    switchBindActive(active) {
      this.bindActive = active;
      this.$emit('changebindActive',active)
    },
    toCreate(){
      //新建档案
      //调用 CreateRecord 组件的 toCreat 方法 
      let comp = this.$refs.CreateRecordcontent;
        // 检查组件实例是否存在
        if (comp && typeof comp.toCreate === 'function') {
          // 调用 NoPatientInformation 组件的 toCreat 方法
          comp.toCreate();
        } else {
          console.error('CreateRecordcontent 组件实例未找到或 toCreat 方法不存在');
        }

    }
  },
};
</script>

<style lang="scss" scoped>


.toptype{
  height: .833rem;
  line-height: .833rem;
  margin-bottom: .208rem;
  background-color: #fff;

  .typebtn{
    position: relative;
    &.active{
      color: #28b8c3;
      border-bottom: .043rem solid #28b8c3;
    }
    
  }
}


.noPatientInformation {
  background-color: #fff;
  padding: 0.25rem 0.167rem;
  box-sizing: border-box;
  border-radius: 0.083rem;
  height: 0px;
}


.noPatientInformation-text{
  font-size: .25rem;
  color: #666;
  margin-bottom: .208rem;
}


.searchPatientInformation {
  text-align: center;
  color: #ccc;
  margin-top: 2.083rem;
}

.Searchpatient {
  height: 0.667rem;
  font-size: 0.25rem;

  .icon-arr-xia {
    color: #ccc;
  }
}

.clinic {
  height: 0.667rem;
  border: 0.021rem solid #ccc;
  border-radius: 0.083rem 0 0 0.083rem;
  line-height: 0.667rem;
  padding-right: 0.208rem;

  .clinicname {
    width: 2.083rem;
    padding: 0 0 0 0.208rem;
  }
}

.nameinfo {
  border: 0.021rem solid #ccc;
  height: 0.667rem;
  border-right: none;
  width: 0rem;
  border-radius: 0.083rem 0 0 0.083rem;

  .nameinput {
    width: 100;
    border: none;
    padding: 0 0.208rem;
    font-size: 0.25rem;
  }
}

.clinic-box{
  margin-top: .208rem;
  font-size: .25rem;
  color: #333;
  .clinic-box-right{
    color: #28b8c3;
    margin-left: .208rem;
    .icon-switch{
      font-size: .25rem;
      margin-left: .104rem;
    }
  }
}

.searchClick {
  font-size: 0.292rem;
  color: #28b8c3;
  border: 0.021rem solid #bfeaed;
  width: 1.042rem;
  border-radius: 0 0.083rem 0.083rem 0;
  line-height: 0.667rem;
  background-color: #eaf8f9;
}

.patientList .patientItem {
  text-align: left;
  position: relative;
  margin-top: 0.5rem;
  border: 0.021rem solid #ccc;
  padding: 0.25rem;
  border-radius: 0.083rem;
  font-size: 0.292rem;

  .isSelect {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 12px;
    top: 12px;
    border: 1.008px solid #ccc;
    border-radius: 50%;

    .iconfont {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -8.016px;
      margin-top: -8.016px;
      color: #fff;
      display: none;
    }

    &.active {
      background-color: #28b8c3;
      border: 1.008px solid #28b8c3;

      .iconfont {
        display: block;
      }
    }
  }

  .name {
    color: #666;

    .main {
      color: #333;
      font-size: 0.313rem;
      font-weight: bold;
    }
  }

  /**患者资料**/

  .patient-left {
    min-width: 1.667rem;
    color: #666666;
  }

  .patient-rightmain {
    color: #333;
  }

  .patient-tag {
    .tagitem {
      padding: 0.083rem 0.167rem;
      font-size: 0.25rem;
      background-color: #f5f5f5;
      color: #333;
      border-radius: 999.024px;
      margin-right: 0.167rem;
      margin-bottom: 0.083rem;
    }
  }

  .titleline {
    color: #333;
    font-size: 0.292rem;
    text-align: left;
    font-weight: bold;
  }

  .seemore {
    font-size: 0.292rem;
    color: #28b8c3;
    margin-top: 0.208rem;
    text-align: center;
  }
}
</style>
